import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'

export default function Disclaimer() {
  return (
    <div className="min-h-screen bg-black text-white" style={{ background: '#000000' }}>
      <nav className="px-6 py-4 border-b border-gray-800">
        <div className="max-w-7xl mx-auto flex items-center gap-4">
          <Link to="/" className="text-gray-400 hover:text-white transition-colors">
            <Home className="w-6 h-6" />
          </Link>
          <h1 className="text-2xl font-bold text-white">Disclaimer</h1>
        </div>
      </nav>
      
      <div className="max-w-4xl mx-auto px-8 py-12">
        <div className="stat-card rounded-2xl p-8 border space-y-6">
          <h2 className="text-3xl font-bold text-white mb-6">Disclaimer</h2>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-3">Educational Purpose</h3>
            <p className="text-gray-400 leading-relaxed">
              Typir is provided as an educational tool to help improve typing skills for coding. The platform is designed for practice and learning purposes only.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-3">No Guarantees</h3>
            <p className="text-gray-400 leading-relaxed">
              While we strive to provide accurate typing statistics and a reliable service, we make no guarantees about the accuracy of WPM calculations, progress tracking, or the availability of the service. Use at your own discretion.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-3">Third-Party Services</h3>
            <p className="text-gray-400 leading-relaxed">
              Typir uses third-party services including Supabase for authentication and data storage. We are not responsible for any issues arising from these third-party services.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-3">Changes to Service</h3>
            <p className="text-gray-400 leading-relaxed">
              We reserve the right to modify, suspend, or discontinue any part of the service at any time without notice. Your data may be deleted if the service is discontinued.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-white mb-3">Liability</h3>
            <p className="text-gray-400 leading-relaxed">
              Typir is provided "as is" without any warranties. We are not liable for any damages or losses arising from the use of this service.
            </p>
          </div>
          
          <p className="text-gray-400 text-sm mt-8">
            Last updated: October 2025
          </p>
          
          <Link to="/" className="btn-secondary inline-block mt-6">
            Back to Practice
          </Link>
        </div>
      </div>
    </div>
  )
}
